import type { GridRenderCellParams } from "@mui/x-data-grid"

import type { DeviceGroupRef } from "types/group.types"

export const getGroupsNames = (groups: DeviceGroupRef[]) =>
  groups.map(({ name }) => name).join(" - ")

export const getGroupsString = (groups: DeviceGroupRef[]) =>
  groups?.length > 0 ? getGroupsNames(groups) : " - "

// The grid's CSV export escapes a leading "-" as a formula ('-), so a missing value exports as an
// empty cell and only the screen shows the dash.
export const renderDashIfEmpty = ({ formattedValue }: GridRenderCellParams) =>
  formattedValue === undefined || formattedValue === null || formattedValue === ""
    ? "-"
    : formattedValue
